module.exports = __webpack_public_path__ + "static/media/films-kill-giants.7a63df57.png";